import React from "react";
import PropTypes from "prop-types";
import { CtaButton } from "../../Elements";
import { CloudinaryImage } from "@website-builder/ui/shared/elements";
import { SocialMediaImagesContainer, Heading } from "./style";

const SocialMediaImages = (props) => {
	const { heading, cta, images } = props;
	return (
		<SocialMediaImagesContainer>
			<Heading>{heading}</Heading>
			<div className="imagesWrapper">
				{images.map((image, index) => (
					<div key={index} className="socialMediaImages">
						<CloudinaryImage
							lazyload
							className="image"
							url={image.imageUrl}
							sizes={{ default: { height: 283 }, "322px": { height: 283 } }}
						/>
					</div>
				))}
			</div>
			<div className="buttonWrapper">
				<CtaButton cta={cta} />
			</div>
		</SocialMediaImagesContainer>
	);
};

SocialMediaImages.propTypes = {
	heading: PropTypes.string,
	cta: PropTypes.shape({
		link: PropTypes.shape({
			type: PropTypes.oneOf(["hash", "external", "internal"]),
			value: PropTypes.string,
		}),
		color: PropTypes.string,
		type: PropTypes.oneOf(["solid", "outline"]),
		text: PropTypes.string,
	}),
	images: PropTypes.array,
};

SocialMediaImages.defaultProps = {
	heading: "",
	cta: null,
	images: [],
};

export default SocialMediaImages;
